var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], {"dev":false,"autoescape":true,"throwOnUndefined":false,"trimBlocks":false,"lstripBlocks":false});
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@templates/components/atoms/image.html.njk"] = require( "@templates/components/atoms/image.html.njk" );
dependencies["@templates/components/molecules/house-feature-list.html.njk"] = require( "@templates/components/molecules/house-feature-list.html.njk" );
dependencies["@naturehouse/design-system/components/protons/icon/Icon.macro.njk"] = require( "@naturehouse/design-system/components/protons/icon/Icon.macro.njk" );




var shim = require("/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/website/search/partials/_searchMapHouseTemplate.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("@templates/components/atoms/image.html.njk", false, "templates/website/search/partials/_searchMapHouseTemplate.html.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("image", t_1);
output += "\n";
env.getTemplate("@templates/components/molecules/house-feature-list.html.njk", false, "templates/website/search/partials/_searchMapHouseTemplate.html.njk", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("houseFeatureList", t_4);
output += "\n";
env.getTemplate("@naturehouse/design-system/components/protons/icon/Icon.macro.njk", false, "templates/website/search/partials/_searchMapHouseTemplate.html.njk", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("iconTemplate", t_7);
output += "\n\n<div class=\"house-detail-container\" data-testid=\"search-map-house-card\">\n    <button\n        class=\"nh-button nh-button--floating nh-button--icon house-detail-card__close-button\"\n        data-close-house-detail-card\n        data-testid=\"close-house-detail-card\"\n    >\n        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 10, colno = 30, runtime.callWrap(runtime.memberLookup((t_7),"render"), "iconTemplate[\"render\"]", context, [{"name": "close","size": "1.125"}]))), env.opts.autoescape);
output += "\n    </button>\n\n    <a\n        href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"websiteUrl"), env.opts.autoescape);
output += "\"\n        class=\"card-image-left\"\n        target=\"_blank\"\n        title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"title"), env.opts.autoescape);
output += "\"\n        data-house-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"), env.opts.autoescape);
output += "\"\n    >\n        ";
output += runtime.suppressValue((lineno = 23, colno = 23, runtime.callWrap(runtime.memberLookup((t_1),"render"), "image[\"render\"]", context, [{"src": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl"),"alt": "title"}])), env.opts.autoescape);
output += "\n\n        <div class=\"card-image-left__content\">\n            <header>\n                <h3 class=\"card__title\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"title"), env.opts.autoescape);
output += "</h3>\n                <span class=\"card-image-left__content__subtitle\">\n                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"locationTitle"), env.opts.autoescape);
output += "\n                </span>\n            </header>\n\n            ";
if(env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")) === true && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice")) {
output += "\n                <div class=\"card-image-left__feature-list\">\n                    ";
output += runtime.suppressValue((lineno = 38, colno = 46, runtime.callWrap(runtime.memberLookup((t_4),"render"), "houseFeatureList[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "house"),runtime.contextOrFrameLookup(context, frame, "translations")])), env.opts.autoescape);
output += "\n                </div>\n            ";
;
}
output += "\n\n            <div class=\"card-image-left__content--footer\">\n                <div class=\"card-image-left__content--footer__item\">\n                    ";
if(env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")) === true && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice")) {
output += "\n                        <div class=\"card-image-left__content--footer__dayprice\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNight"), env.opts.autoescape);
output += "\n                            <span>";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"),"EUR"), env.opts.autoescape);
output += "</span>\n                        </div>\n                    ";
;
}
else {
output += "\n                        <div class=\"card-image-left__feature-list\">\n                            ";
output += runtime.suppressValue((lineno = 51, colno = 54, runtime.callWrap(runtime.memberLookup((t_4),"render"), "houseFeatureList[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "house"),runtime.contextOrFrameLookup(context, frame, "translations")])), env.opts.autoescape);
output += "\n                        </div>\n                    ";
;
}
output += "\n                </div>\n\n                <span class=\"card-image-left__button--arrow\">\n                    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 57, colno = 42, runtime.callWrap(runtime.memberLookup((t_7),"render"), "iconTemplate[\"render\"]", context, [{"name": "arrow-right","size": "1.125"}]))), env.opts.autoescape);
output += "\n                </span>\n            </div>\n        </div>\n    </a>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/website/search/partials/_searchMapHouseTemplate.html.njk"] , dependencies)